import { combineReducers } from 'redux';
import { invitationActionTypes } from './Invitation.actionTypes';

const invitationDataReducer = (state = {}, action) => {
  switch (action.type) {
    case invitationActionTypes.SET_INVITATION_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

const invitationReducer = combineReducers({
  invitationData: invitationDataReducer,
});
export default invitationReducer;
